enum AccessResult {
    SUCCESS,
    EXPIRED,
    NO_ACCESS,
    INCORRECT_DETAILS,
}

export default AccessResult;